export default __webpack_public_path__ + "static/media/texas_BaseTry1.95f84f87.svg";